(ns teamoesterreich.admin-mode.data.eventMember
  (:require [clojure.walk]
            [goog.json :as json]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.ajax :as ajax]
            [teamoesterreich.util.download :as h-download]
            [teamoesterreich.util.log :as log]))





(defn >member-save [uuid data done-fn]
  (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-member/" uuid)
                  (ajax/serialize data)
                  (fn [r-list status]
                    (log/debug ">event->member-save done" r-list status)
                    (if (= status 200)
                      (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                      (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                               )))))

(defn >multi-member-save [uuid data done-fn]
  ;TODO
  )


(defn >member-drop [uuid done-fn]
  (ajax/auth-delete> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-member/" uuid)
                     (fn [r-list status]
                       (log/debug ">event->member-drop done" r-list status)
                       (if (< status 400)
                         (done-fn)
                         (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                                  )))))

(defn >members-set [event-uuid member-uuids action slot-uuid done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-member/" event-uuid "/members-action?action=" action "&slot-uuid=" slot-uuid)
                   (ajax/serialize member-uuids)
                   (fn [r-list status]
                     (log/debug "d-eventMember/>members-set " (count member-uuids) " done" r-list status)
                     (if (= status 200)
                       (done-fn)
                       (done-fn {:error (str "Fehler: Aktion konnte nicht durchgeführt werden! " status)}
                                )))))




(defn open-csv [event-uuid filter-response filter-mission]
  (h-download/open-download-url (backend/get-auth) (str backend/BASE_URL "/download/crowdtasker-event-members/" event-uuid "?filter-response=" filter-response "&filter-mission=" filter-mission)))













